
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3><em parentName="h3">{`[Deprecated]`}</em>{` `}<inlineCode parentName="h3">{`"innerRef"`}</inlineCode>{` prop`}</h3>
    <blockquote>
      <p parentName="blockquote">{`The `}<inlineCode parentName="p">{`"innerRef"`}</inlineCode>{` prop was removed in styled-components v4 in favor of the `}<a parentName="p" {...{
          "href": "https://reactjs.org/docs/forwarding-refs.html"
        }}>{`React 16 `}<inlineCode parentName="a">{`forwardRef`}</inlineCode>{` API`}</a>{`. Just use the normal `}<inlineCode parentName="p">{`ref`}</inlineCode>{` prop instead.`}</p>
    </blockquote>
    <p>{`Passing a `}<inlineCode parentName="p">{`ref`}</inlineCode>{` prop to a styled component will give you an instance of
the `}<inlineCode parentName="p">{`StyledComponent`}</inlineCode>{` wrapper, but not to the underlying DOM node.
This is due to how refs work.
It's not possible to call DOM methods, like `}<inlineCode parentName="p">{`focus`}</inlineCode>{`, on our wrappers directly.`}</p>
    <p>{`To get a ref to the actual, wrapped DOM node, pass the callback to the `}<inlineCode parentName="p">{`innerRef`}</inlineCode>{` prop instead.`}</p>
    <blockquote>
      <p parentName="blockquote">{`We don't support string refs (i.e. `}<inlineCode parentName="p">{`innerRef="node"`}</inlineCode>{`), since they're already deprecated in React.`}</p>
    </blockquote>
    <p>{`This example uses `}<inlineCode parentName="p">{`innerRef`}</inlineCode>{` to save a ref to the styled input and focuses it once the user
hovers over it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Input = styled.input\`
  padding: 0.5em;
  margin: 0.5em;
  color: palevioletred;
  background: papayawhip;
  border: none;
  border-radius: 3px;
\`

class Form extends React.Component {
  render() {
    return (
      <Input
        placeholder="Hover here..."
        innerRef={x => {
          this.input = x
        }}
        onMouseEnter={() => this.input.focus()}
      />
    )
  }
}
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;